<script setup>
import { computed } from 'vue';
import KanbanColumn from './KanbanColumn.vue';

const props = defineProps({
  pipeline: {
    type: Object,
    required: true,
  },
  deals: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits([
  'move-deal',
  'edit-deal',
  'click-deal',
  'new-deal-in-stage',
  'edit-stage',
]);

const sortedStages = computed(() => {
  if (!props.pipeline || !props.pipeline.stages) return [];
  return [...props.pipeline.stages].sort((a, b) => (a.position || 0) - (b.position || 0));
});
</script>

<template>
  <div class="flex-1 flex gap-3.5 overflow-x-auto p-4 select-none items-start h-full">
    <KanbanColumn
      v-for="stage in sortedStages"
      :key="stage.id"
      :stage="stage"
      :deals="deals"
      @move-deal="emit('move-deal', $event)"
      @edit-deal="emit('edit-deal', $event)"
      @click-deal="emit('click-deal', $event)"
      @new-deal-in-stage="emit('new-deal-in-stage', $event)"
      @edit-stage="emit('edit-stage', $event)"
    />

    <div
      v-if="sortedStages.length === 0"
      class="flex-1 flex flex-col items-center justify-center p-12 text-slate-400 dark:text-slate-500"
    >
      <svg class="w-10 h-10 mb-2.5 stroke-[1.5]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
      </svg>
      <p class="text-sm font-medium">Este funil ainda não tem etapas configuradas.</p>
    </div>
  </div>
</template>
